
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import axios from "@/plugins/http";

const DELETE_CASE_ACTION_TYPE = "deleteCase";
const DELETE_CASE_PLUS_CANDIDATE_PROFILE_ACTION_TYPE = "deleteCasePlusCandidateProfile";
const DELETE_CASE_PLUS_EC_ACTION_TYPE = "deleteCasePlusEC";

@Component
export default class DeleteCasePopUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;
  @Prop({ type: String }) readonly action?: string;
  @Prop({ type: [String, Number] }) readonly serviceId?: string | number;

  showPopup = false;

  // TODO: Refactor it, after refactoring "Nb-dialog" component;
  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  get title() {
    const { action } = this;

    if (!action) return "";

    return this.$tc(`titles.${action}`);
  }

  get text() {
    const { action } = this;

    if (!action) return "";

    return this.$tc(`texts.${action}`);
  }

  getUrl() {
    const { action, serviceId } = this;

    if (!action || !serviceId) return "";

    if (action === DELETE_CASE_ACTION_TYPE) {
      return API_ROUTES.EXPERT_CASE_DELETE(serviceId);
    }

    if (action === DELETE_CASE_PLUS_CANDIDATE_PROFILE_ACTION_TYPE) {
      return API_ROUTES.EXPERT_CASE_DELETE_PLUS_CANDIDATE_PROFILE(serviceId);
    }

    if (action === DELETE_CASE_PLUS_EC_ACTION_TYPE) {
      return API_ROUTES.EXPERT_CASE_DELETE_PLUS_EC(serviceId);
    }

    return "";
  }

  async confirm() {
    try {
      if (!this.action) return;

      const url = this.getUrl();

      if (!url) return;

      await axios.delete(url);

      this.$emit("success");
    } finally {
      this.close();
    }
  }
}
